import React from 'react';

export default function PreviewModePill({
  variant = 'set',
  context = 'title',
  children,
  className = '',
  style,
  title,
}) {
  const contextClass = context === 'inline' ? 'preview-mode-pill--inline' : '';
  return (
    <span
      className={`preview-mode-pill ${contextClass} preview-mode-pill--${variant}${className ? ` ${className}` : ''}`}
      style={style}
      title={title}
    >
      {children}
    </span>
  );
}
